function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 4.58314,
  fill: "#F7F8FB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.0002 19.9553L30.4649 22.9999L22.0002 19.9553L30.4649 16.9999L39.0002 19.9553Z",
  fill: "#E9EDF5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4018 21.5401L14.7403 29.7587L6.52602 33.2681L10.2054 25.1666L18.4018 21.5401Z",
  fill: "#CCD3E2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5041 6.62556L29.8426 14.8441L21.6283 18.3536L25.3077 10.2521L33.5041 6.62556Z",
  fill: "#CCD3E2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9766 22.2548L23.1728 30.6652L19.8203 38.9448L16.7193 30.6047L19.9766 22.2548Z",
  fill: "#E9EDF5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1759 1.02967L23.3721 9.44008L20.0195 17.7197L16.9185 9.37961L20.1759 1.02967Z",
  fill: "#E9EDF5"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M6.81778 6.41669L15.0022 10.1537L18.4359 18.4L10.3686 14.6461L6.81778 6.41669Z",
  fill: "#CCD3E2"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M33.0614 33.741L29.6963 25.3967L21.6128 21.5955L25 29.8235L33.0614 33.741Z",
  fill: "#CCD3E2"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M1.14378 19.6778L9.47704 23.0701L17.8329 19.9124L9.56772 16.6169L1.14378 19.6778Z",
  fill: "#E9EDF5"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6044 27.0309C18.4612 27.0309 18.3324 26.9808 18.2179 26.8806C18.1176 26.766 18.0675 26.6372 18.0675 26.494V16.2731L15.1258 18.5277C15.0256 18.6136 14.9182 18.6565 14.8037 18.6565C14.6462 18.6565 14.5031 18.5706 14.3743 18.3989L13.1074 16.7455C13.0358 16.6309 13 16.5236 13 16.4234C13 16.223 13.0859 16.0726 13.2577 15.9724L18.1964 12.1503C18.3538 12.0501 18.5256 12 18.7117 12H21.3958C21.5533 12 21.6821 12.0501 21.7823 12.1503C21.8825 12.2505 21.9326 12.3794 21.9326 12.5368V26.494C21.9326 26.6372 21.8825 26.766 21.7823 26.8806C21.6821 26.9808 21.5533 27.0309 21.3958 27.0309H18.6044Z",
  fill: "#6680DE"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.4737 27.6247L17.4276 27.572C17.1714 27.2792 17.0175 26.9084 17.0175 26.4941V18.4007L15.7819 19.3477C15.5256 19.5583 15.1927 19.7065 14.8037 19.7065C14.208 19.7065 13.7881 19.3652 13.5381 19.034L12.2434 17.3444L12.2169 17.302C12.0762 17.0769 11.95 16.7776 11.95 16.4234C11.95 15.8812 12.2041 15.4049 12.6566 15.1099L17.5919 11.2904L17.6326 11.2645C17.958 11.0574 18.3253 10.95 18.7117 10.95H21.3958C21.7978 10.95 22.2049 11.088 22.5247 11.4079M22.5247 11.4079C22.8446 11.7277 22.9826 12.1348 22.9826 12.5368V26.4941C22.9826 26.9084 22.8287 27.2792 22.5725 27.572L22.5495 27.5983L22.5247 27.623C22.2049 27.9429 21.7978 28.0809 21.3958 28.0809H18.6043C18.1899 28.0809 17.8192 27.927 17.5264 27.6708L17.4737 27.6247M13.2576 15.9725C13.0858 16.0727 13 16.223 13 16.4234C13 16.5236 13.0357 16.6309 13.1073 16.7455L14.3742 18.3989C14.503 18.5706 14.6462 18.6565 14.8037 18.6565C14.9182 18.6565 15.0255 18.6136 15.1257 18.5277L18.0675 16.2731V26.4941C18.0675 26.6372 18.1176 26.766 18.2178 26.8806C18.3323 26.9808 18.4612 27.0309 18.6043 27.0309H21.3958C21.5532 27.0309 21.6821 26.9808 21.7823 26.8806C21.8825 26.766 21.9326 26.6372 21.9326 26.4941V12.5368C21.9326 12.3794 21.8825 12.2505 21.7823 12.1503C21.6821 12.0501 21.5532 12 21.3958 12H18.7117C18.5256 12 18.3538 12.0501 18.1963 12.1503L13.2576 15.9725Z",
  fill: "#F7F8FB"
});

function SvgTileBegin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileBegin);
export default __webpack_public_path__ + "static/media/tile-begin.da8863f6.svg";
export { ForwardRef as ReactComponent };